<template>
  <div
    v-if="notSaleProducts.length"
    class="notSaleProductsList-wrap"
  >
    <div class="clearfix mlr mt-24 mb-24">
      <h3
        class="text-bold-c111 font-s20 fl"
        style="line-height: 28px;"
      >
        {{TLang('失效商品', 'orderConfirm')}}({{ notSaleProducts.length }})
      </h3>
      <!-- <div
        class="btn-default-w64 fr"
        @click="onClearProducts"
      >
        清空
      </div> -->
    </div>
    <div>
      <div class="order-thead card-default clearfix">
        <div class="font-666 fl">
          {{ TLang("商品信息", "orderConfirm") }}
        </div>
        <div class="font-666 fl">
          {{ TLang("说明", "orderConfirm") }}
        </div>
      </div>
      <div class="order-tbody plr">
        <!-- 遍历失效商品 notSaleProducts -->
        <div
          v-for="item in notSaleProducts"
          :key="item.id"
          class="order-tbody-item clearfix prelative"
        >
          <div class="fl clearfix">
            <label class="tag-default tag-center fl">
              {{ TLang("失效", "orderConfirm") }}</label>
            <img
              :src="item.mallGoodsDto.imgGuide"
              alt="not sale img"
              :class="['product-img', 'fl', 'ml-40', 'mr-8', df_lang && df_lang == 'en-US' ? ' imgEn' : '']"
            />
            <div
              class=""
              style="max-width: 410px; overflow:hidden"
            >
              <div
                class="font-c999 line-clamp-1"
              >
                <i
                  :style="{ fontStyle: 'normal'}"
                >
                  <SingleTag :show="item.mallGoodsDto.giftType == 4" :datas="{name: TLang('奖品', 'list')}" :putName="'PrizeGoods'" />
                </i>
                {{ item.mallGoodsDto.name }}
              </div>
              <div class="font-c999 mt-12">
                {{ TLang("规格", "orderConfirm") }}：{{ item.mallGoodsDto.specValue1
                }}{{ item.mallGoodsDto.specValue2 }}
              </div>
              <div class="font-c999 mt-12">
                {{ TLang("数量", "orderConfirm") }}：{{ item.mallGoodsDto.num }}
              </div>
            </div>
          </div>
          <div class="text fl">
            {{ transformMessage(item.errorCode) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import SingleTag from '@components/singleTag';
export default {
  name: 'NotSaleProductsList',
  components: {
    SingleTag,
  },
  props: {
    notSaleProducts: Array,
  },
  data(){
    return {
      df_lang: Cookies.get('df_lang'),
    };
  },
  methods: {
    onClearProducts() {
      console.log('do empty');
    },
    transformMessage(code){
      switch (code) {
      case 1:
        return this.TLang('该商品已下架', 'orderConfirm');
      case 2:
        return this.TLang('该商品在收货地址内不可售', 'orderConfirm');
      case 3:
        return this.TLang('该商品在收货地址内库存不足', 'orderConfirm');
      default:
        return this.TLang('该商品已下架', 'orderConfirm');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.order-thead,
.order-tbody-item {
  :first-of-type {
    width: 70%;
  }

  :last-of-type {
    width: auto;
  }
}

.order-tbody-item {
  padding: 16px 0;
  border-bottom: solid 1px #e5e5e5;
  &:last-of-type {
    border-bottom: none;
  }
  .tag-center {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .product-img {
    width: 90px;
    height: 90px;
    overflow: hidden;
    display: inline-block;
  }
  .imgEn {
    margin-left: 58px !important;
  }
}
</style>
